<template>
    <svg
        height="24px"
        width="24px"
        id="budget"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25.975 32"
        style="fill: currentColor"
    >
        <path
            id="Tracé_63"
            data-name="Tracé 63"
            d="M336.643,15.336h5.172l-6.549-6.549v5.172A1.378,1.378,0,0,0,336.643,15.336Z"
            transform="translate(-316.321 -8.306)"
        />
        <path
            id="Tracé_64"
            data-name="Tracé 64"
            d="M67.715,9.908A3.452,3.452,0,0,1,64.267,6.46V0H51.648A3.452,3.452,0,0,0,48.2,3.448v25.1A3.452,3.452,0,0,0,51.648,32H70.727a3.452,3.452,0,0,0,3.448-3.448V9.908Zm-7.531,8.167h2.008a2.946,2.946,0,0,1,0,5.892h-.067v1.071a.937.937,0,1,1-1.875,0V23.967H58.175a.938.938,0,0,1,0-1.875h4.017a1.071,1.071,0,0,0,0-2.142H60.183a2.946,2.946,0,1,1,0-5.892h.067V12.988a.938.938,0,0,1,1.875,0v1.071H64.2a.937.937,0,0,1,0,1.875H60.183a1.071,1.071,0,1,0,0,2.141Z"
            transform="translate(-48.2 0)"
        />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-expense-report",
});
</script>
